module.exports = __webpack_public_path__ + "static/media/icon-long-arrow-right.fba1b7cb.svg";